export default class Behavior {
    constructor({ id = '', payload = null } = {}) {
        this.id = id;
        this.payload = payload;
    }
}
